<template>
  <div>
    <basic-container>
      <div>
        <el-form
          ref="form"
          :model="customerForm"
          disabled
        >

          <el-form-item
            label="客户姓名"
            label-width="100px"
          >

            <div style="display: flex;width:300px;">
              <el-input
                v-model="customerForm.name"
                placeholder='请输入客户姓名'
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item
            label="客户电话"
            label-width="100px"
          >

            <div style="display: flex;width:300px;">
              <el-input
                v-model="customerForm.mobile"
                placeholder='请输入客户电话'
              ></el-input>
            </div>
          </el-form-item>

          <el-form-item
            label="客户地址"
            label-width="100px"
          >

            <div style="display: flex;width:300px;">
              <avue-map v-model="point"></avue-map>
              <el-input
                type="input"
                name="title"
                v-model="point.address"
              ></el-input>
            </div>
          </el-form-item>
          <el-form-item label="服务预约配置">
            <el-table
              :data="tableData"
              :span-method="objectSpanMethod"
              border
              style="width: 100%; margin-top: 20px"
            >
            <el-table-column prop="clientType" align="center" label="工程服务项目">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.serviceCategory" placeholder="请选择" required
                    @change="choseWorkServiceItem" value-key="id">
                    <el-option v-for="serviceCategory in serviceCategorys" :key="serviceCategory.id"
                      :label="serviceCategory.name" :value="serviceCategory"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="操作"
                min-width="120"
              >
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    icon="el-icon-close"
                    size="small"
                    @click="handleSteppingDelete(scope.$index, scope.row)"
                  >删除
                  </el-button>
                  <el-button
                    type="primary"
                    icon="el-icon-view"
                    size="small"
                    @click="toDetail(scope.$index, scope.row)"
                  >查看服务数据
                  </el-button>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="配置"
                width="150"
              >
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    icon="el-icon-check"
                    size="small"
                    @click="handleAddRows(scope.$index, scope.row)"
                  >增加一行</el-button>
                </template>
              </el-table-column>
              <template slot="empty">
                <el-button
                  type="warning"
                  icon="el-icon-check"
                  size="small"
                  style="margin: 20px 0"
                  @click="handleAddRows()"
                >增加一行</el-button>
              </template>
            </el-table>
          </el-form-item>
          <el-form-item label="动态参数配置">
            <el-table
              :data="tableData1"
              :span-method="objectSpanMethod"
              border
              style="width: 100%; margin-top: 20px"
            >

              <el-table-column
                prop="parameterName"
                label="显示名称"
              >
                <template slot-scope="scope">
                  <el-input
                    type="input"
                    name="parameterName"
                    v-model="scope.row.parameterName"
                    :value="scope.row.parameterName"
                    placeholder="请输入名称"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="currControlType"
                min-width="150"
                label="控件类型"
              >
                <template slot-scope="scope">
                  <div>
                    <div v-if='scope.row.isMessageReminder =="YES"'>
                      <el-select
                        name="currControlType"
                        v-model="scope.row.currControlType"
                        placeholder="请选择控件类型"
                        clearable
                        value-key="value"
                        disabled
                      >
                        <el-option
                          v-for="item in currControlTypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                    <div v-else>
                      <el-select
                        name="currControlType"
                        v-model="scope.row.currControlType"
                        placeholder="请选择控件类型"
                        clearable
                        @change="changeInputType(scope.row.currControlType,scope)"
                        value-key="value"
                      >
                        <el-option
                          v-for="item in currControlTypes"
                          :key="item.value"
                          :label="item.label"
                          :value="item"
                        >
                        </el-option>
                      </el-select>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="datas"
                min-width="150"
                label="参数数据"
              >
                <template slot-scope="scope">
                  <el-input
                    type="textarea"
                    name="datas"
                    v-if="scope.row.currControlType.value =='RADIO'|| scope.row.currControlType.value =='CHECKBOX'"
                    v-model="scope.row.datas"
                    :value="scope.row.datas"
                    @blur="blurDataSource(scope)"
                    placeholder="请换行输入参数数据"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="dynamic"
                min-width="250"
                label="动态控件"
              >
                <template slot-scope="scope">
                  <div>
                    <!-- datas -->
                    <div v-if='scope.row.currControlType.value =="RADIO"'>
                      <div
                        v-for="(item,index) in scope.row.dataSourceList"
                        :key='index'
                      >
                        <el-radio
                          v-model="scope.row.data.isRadio"
                          :label="item"
                        >
                        </el-radio>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value =="CHECKBOX"'>
                      <div>
                        <el-checkbox-group v-model="scope.row.dynamicCheckList">
                          <el-checkbox
                            v-for="(item,index) in scope.row.dataSourceList"
                            :label="item"
                            :key='index'
                          ></el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value =="INT_INPUT"'>
                      {{scope.row.message}}
                      <div>
                        <el-input
                          type="text"
                          name="intInput"
                          onkeyup="value=value.replace(/\D/g,'')"
                          v-model="scope.row.data.intInput"
                          :value="scope.row.data.intInput"
                        ></el-input>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value =="FLOAT_INPUT"'>
                      <div>
                        <el-input
                          type="text"
                          name="floatInput"
                          onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
                          v-model="scope.row.data.floatInput"
                          :value="scope.row.data.floatInput"
                        ></el-input>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value =="INPUT"'>
                      <div>
                        <el-input
                          type="text"
                          name="input"
                          v-model="scope.row.data.input"
                          :value="scope.row.data.input"
                        ></el-input>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value =="TIME"'>
                      <div>
                        <el-time-picker
                          v-model="scope.row.data.timeDate"
                          placeholder="选择时间"
                          value-format="timestamp"
                        >
                        </el-time-picker>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value =="DATE"'>
                      <div>
                        <el-date-picker
                          v-model="scope.row.data.dateDate"
                          type="date"
                          placeholder="选择日期"
                          value-format="timestamp"
                        >
                        </el-date-picker>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value =="DATE_TIME"'>
                      <div>
                        <el-date-picker
                          v-model="scope.row.data.dateTimeDate"
                          type="datetime"
                          placeholder="选择日期时间"
                          value-format="timestamp"
                        >
                        </el-date-picker>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value =="ADDRESS"'>
                      <div style="display: flex;width:300px;">
                        <avue-map v-model="scope.row.data"></avue-map>
                        <el-input
                          type="input"
                          name="title"
                          v-model="scope.row.data.address"
                        ></el-input>
                      </div>
                    </div>
                    <div>
                      <div>
                        <el-select
                          v-model="scope.row.selectEngineer"
                          placeholder="请选择服务人员"
                          filterable
                          v-if='scope.row.currControlType.value =="SELECT_ENGINEER"'
                          value-key="id"
                          remote
                          :remote-method="remoteMethodDynamic"
                          @change="remoteDynamic(scope)"
                        >
                          <el-option
                            v-for="item2 in scope.row.selectEngineerList"
                            :key="item2.id"
                            :label="item2.realName"
                            :value="item2"
                          ></el-option>
                        </el-select>
                      </div>
                    </div>
                    <div>
                      <div>
                        <el-select
                          v-model="scope.row.multipleSelectEngineer"
                          placeholder="请选择服务人员"
                          multiple
                          filterable
                          v-if='scope.row.currControlType.value =="MULTIPLE_SELECT_ENGINEER"'
                          value-key="id"
                        >
                          <el-option
                            v-for="item2 in scope.row.multipleSelectEngineerList"
                            :key="item2.id"
                            :label="item2.realName"
                            :value="item2"
                          ></el-option>
                        </el-select>
                      </div>
                    </div>
                    <div v-if='scope.row.currControlType.value =="PICTURE"'>
                      <div>
                        <el-dialog :visible.sync="dialogVisible">
                          <img
                            width="100%"
                            :src="dialogImageUrl"
                            alt=""
                          >
                        </el-dialog>
                        <el-upload
                          class="upload-demo"
                          action="#"
                          accept=".jpg, .jpeg,.png"
                          :on-remove="handleRemove"
                          :multiple="true"
                          :http-request="fnUploadDescribeImgs"
                          list-type="picture-card"
                          :on-preview="handlePreview"
                          :on-exceed="handleExceed"
                          :file-list="scope.row.fileList"
                        >
                          <el-button
                            size="small"
                            type="primary"
                            @click="isIndex(scope.row,scope.$index)"
                          >点击上传</el-button>
                          <div
                            slot="tip"
                            class="el-upload__tip"
                          >只能上传jpg/png文件，且不超过500kb</div>
                        </el-upload>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="isMessageReminder"
                label="是否消息提醒"
                width="150"
              >
                <template slot-scope="scope">
                  <el-radio
                    v-model="scope.row.isMessageReminder"
                    label="YES"
                    @change="changeIsReminder(scope)"
                  >
                    是
                  </el-radio>
                  <el-radio
                    v-model="scope.row.isMessageReminder"
                    @change="changeIsReminder(scope)"
                    label="NO"
                  >
                    否
                  </el-radio>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                label="操作"
                width="120"
              >

                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    icon="el-icon-close"
                    size="small"
                    @click="handleStepping1Delete(scope.$index, scope.row)"
                  >删除
                  </el-button>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="配置"
                width="150"
              >
                <template slot-scope="scope">
                  <el-button
                    type="warning"
                    icon="el-icon-check"
                    size="small"
                    @click="handleAdd1Rows(scope.$index, scope.row)"
                  >增加一行</el-button>
                </template>
              </el-table-column>
              <template slot="empty">
                <el-button
                  type="warning"
                  icon="el-icon-check"
                  size="small"
                  style="margin: 20px 0"
                  @click="handleAdd1Rows()"
                >增加一行</el-button>
              </template>
            </el-table>
          </el-form-item>
        </el-form>
        <div style='width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:20px'>
          <el-button
            type="primary"
            size="big"
            @click="submit"
          >返回上级</el-button>
        </div>
      </div>

    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
import { resolveUrlPath, setUrlPath } from "@/util/util";
import {
  findAllSuperiorDepartment,
  addProject,
  findProvince,
  findCustomerInfoDetail,
  findCitys,
  findAreas,
  findUsersList,
  findDataSourceFields,
  findDataSourceAll,
  updateCustomer,
  findUsersAll
} from "@/api/salesCloud/customerInfo";
import { findUserList } from "@/api/salesCloud/bindEngineer";
import {
  findCategoryAll,
  findItemsByCategory
} from "@/api/salesCloud/workOrder";
export default {
  data() {
    return {
      customerForm: {},
      dialogImageUrl: "",
      isPas: false,
      isTop: "YES",
      point: {},
      dialogVisible: false,
      currIndex: {},
      fileList: [],
      currservicePeoplesList: [],
      currControlTypes: DIC.CONTROL_TYPE,
      clientTypes: DIC.SERVICEITEM_TYPE,
      payers: DIC.SERVICEITEM_PAYER,
      auditors: DIC.SERVICEITEM_PAYER,
      serviceCategorys: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      serviceItem: {},
      areas: [],
      citys: [],
      provinces: [],
      tableData: [],
      tableData1: []
    };
  },
  created() {
    // let params = {};
    // params.userType = "JOINS_ENGINEER";
    // findUsersAll(params).then(res => {
    //   let data = JSON.parse(res.data);
    //   this.currservicePeoples = data.rows;
    // });
    findCategoryAll().then(res => {
      let data = JSON.parse(res.data);
      this.serviceCategorys = data;
    });
    findCustomerInfoDetail(this.$router.currentRoute.query.id).then(res => {
      let data = JSON.parse(res.data);
      this.customerForm.name = data.name;
      this.customerForm.mobile = data.mobile;
      this.point.location = {};
      this.point.location.lng = data.longitude;
      this.point.location.lat = data.latitude;
      this.point.pcode = data.province;
      this.point.adcode = data.city;
      this.point.adcode = data.area;
      this.point.pname = data.provinceName;
      this.point.cityname = data.cityName;
      this.point.adname = data.areaName;
      this.point.address = data.address;
      let tableData = [];
      console.log(data);
      // //服务人员回显
      for (let i of data.services) {
        let obj = {};
        obj.currservicePeople = {};
        obj.currservicePeopleList = [];
        // this.currservicePeoplesList = [];
        console.log(i);
        let params = {};
        params.id = i.servicePeople;
        findUsersList(params).then(res => {
          let data = JSON.parse(res.data);
          console.log(data);
          console.log(this.currservicePeoplesList);
          for (let j of data) {
            this.currservicePeoplesList.push(j);
          }
          // let arr1 = this.currservicePeoplesList.reduce(function(item, next) {
          //   console.log(item);
          //   console.log(next);
          // }, []);
          // console.log(arr1);
          let currservicePeople = i.servicePeople.split(","); //多选服务工程师
          // let arr = [];
          // for (let j of currservicePeople) {
          //   console.log(j);
          //   let jobj = {};
          //   jobj.id = j;
          //   arr.push(jobj);
          // }
          // console.log(arr);
          this.$nextTick(() => {
            obj.currservicePeople = currservicePeople;
          });
        });
        // let ids = i.servicePeople.split(",");
        // for (let j of ids) {
        //   console.log(j);
        //   if (j != "") {
        //     let obj = {};
        //     obj.id = j;
        //     arr.push(obj);
        //   }
        // }
        obj.serviceCategory = {};
        console.log(111);
        if (i.serviceStatus != null) {
          obj.serviceCategory.id = i.serviceStatus.split(",")[0];
          obj.serviceItem = {};
          obj.joinsWorkServiceItems = [];

          findItemsByCategory(obj.serviceCategory.id).then(res => {
            let data = JSON.parse(res.data);
            obj.joinsWorkServiceItems = data;
          });
          obj.serviceItem.id = i.serviceStatus.split(",")[1];
        } else {
          obj.joinsWorkServiceItems = [];
        }

        obj.serviceTime = i.serviceTime;
        obj.id = i.id;
        obj.workId = i.workId;
        tableData.push(obj);
      }
      console.log(tableData);
      this.tableData = tableData;
      let tableData1 = [];
      console.log(data);
      // //服务人员回显
      for (let i of data.vices) {
        console.log(i);
        let obj = {};
        obj.data = i.data; //数据
        obj.id = i.id;
        obj.parameterName = i.parameterName;
        obj.isMessageReminder = i.isMessageReminder;
        obj.parameterData = i.parameterData;
        obj.currControlType = {};
        obj.dataSourceList = [];
        obj.dynamicCheckList = []; //多选
        obj.selectEngineer = {}; //单选服务工程师
        obj.selectEngineerList = []; //单选服务工程师
        obj.multipleSelectEngineer = {}; //多选服务工程师
        obj.multipleSelectEngineerList = []; //多选服务工程师
        obj.point = {}; //地址
        obj.fileList = []; //图片
        obj.currControlType.value = i.controlType;

        // selectEngineerList: [],
        // isMessageReminder: "NO",
        // fileList: [],
        // data: {}

        // if (i.controlType == "INT_INPUT") {
        //   obj.intInput = i.data.intInput; //整数输入文本框
        // }
        // if (i.controlType == "FLOAT_INPUT") {
        //   obj.floatInput = i.data.floatInput; //小数输入文本框
        // }
        // if (i.controlType == "INPUT") {
        //   obj.input = i.data.input; //输入文本框
        // }
        if (i.controlType == "PICTURE") {
          if (i.data.fileList) {
            let arr = i.data.fileList.split(",");
            console.log(arr.length);
            let jarr = [];
            for (let j = 0; j < arr.length; j++) {
              console.log(arr[j]);
              let obj = {};
              obj.name = i.data.fileName.split(",")[j];
              obj.url = arr[j];
              jarr.push(obj);
            }
            obj.fileList = jarr;
          }

          // obj.fileList = i.data.fileList; //图片
        }
        if (i.controlType == "TIME") {
          obj.timeDate = i.data.timeDate; //选择时间
        }
        if (i.controlType == "DATE") {
          obj.dateDate = i.data.dateDate; //选择日期
        }
        if (i.controlType == "DATE_TIME") {
          obj.dateTimeDate = i.data.dateTimeDate; //选择日期和时间
        }
        if (i.controlType == "RADIO") {
          obj.datas = i.dataSource;
          obj.dataSourceList = i.dataSource.split(/[(\r\n)\r\n]+/);
          obj.isRadio = i.data.isRadio; //单选
          console.log(obj);
        }
        if (i.controlType == "CHECKBOX") {
          console.log(obj);
          obj.datas = i.dataSource;
          obj.dataSourceList = i.dataSource.split(/[(\r\n)\r\n]+/);
          obj.dynamicCheckList = i.data.dynamicCheckList.split(","); //多选
        }
        if (i.controlType == "SELECT_ENGINEER") {
          let params = {};
          params.id = i.data.selectEngineer;
          findUsersList(params).then(res => {
            let data = JSON.parse(res.data);
            obj.selectEngineerList = data;
            let selectEngineer = {};
            selectEngineer.id = i.data.selectEngineer; //单选服务工程师
            obj.selectEngineer = selectEngineer;
          });
        }
        if (i.controlType == "MULTIPLE_SELECT_ENGINEER") {
          let params = {};
          params.id = i.data.multipleSelectEngineer;
          findUsersList(params).then(res => {
            let data = JSON.parse(res.data);
            console.log(data);
            obj.multipleSelectEngineerList = data;
            let multipleSelectEngineer = i.data.multipleSelectEngineer.split(
              ","
            ); //多选服务工程师
            let arr = [];
            for (let j of multipleSelectEngineer) {
              let jobj = {};
              jobj.id = j;
              arr.push(jobj);
            }
            obj.multipleSelectEngineer = arr;
          });
        }
        // if (i.controlType == "ADDRESS") {
        //   if (i.point) {
        //     obj.longitude = i.data.point.location.lng;
        //     obj.latitude = i.data.point.location.lat;
        //     obj.province = i.data.point.pcode;
        //     obj.city = i.data.point.adcode.substring(0, 4) + "00";
        //     obj.area = i.data.point.adcode;
        //     obj.provinceName = i.data.point.pname;
        //     obj.cityName = i.data.point.cityname;
        //     obj.areaName = i.data.point.adname;
        //     obj.address = i.data.point.address;
        //   }
        // }
        console.log(obj);
        tableData1.push(obj);
      }
      console.log(tableData1);
      this.tableData1 = tableData1;
    });
  },
  methods: {
    remoteMethodDynamic(query) {
      console.log(query);
    },
    remoteDynamic(scope) {
      console.log(scope);
    },
    clickRow(row) {
      console.log(row);
    },
    deWeight(arr) {
      for (let i = 0; i < arr.length - 1; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i].name == arr[j].name) {
            arr.splice(j, 1);
            //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
            j--;
          }
        }
      }
      return arr;
    },
    remoteMethod(query) {
      console.log(query);
      if (query.length == 5) {
        this.currservicePeoplesList = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query
          };
          findUserList(params).then(res => {
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              for (let k of data) {
                this.currservicePeoplesList.push(k);
              }

              // let arr1 = []; //现有list列表
              // for (let i of this.tableData) {
              //   console.log(i);

              //   for (let j of this.currservicePeoplesList) {
              //     console.log(j);
              //     console.log(data);
              //     // i.currservicePeopleList.push(...data);
              //     arr1.push(j);
              //   }
              // }
              // console.log(this.deWeight(arr1));
              // console.log(arr1);

              //     i.currservicePeopleList.push(...data);
              // for (let j of data) {
              //   for (let i of this.tableData) {
              //     // i.currservicePeopleList.push(...data);
              //     console.log(i);
              //     for (let k of i.currservicePeopleList) {
              //       if (k.id == j.id) {
              //         data.splice(data.indexOf(j),1)
              //       }
              //       console.log(j);
              //       console.log(data);

              //       // i.currservicePeopleList.push(...data);
              //     }
              //     i.currservicePeopleList.push(...data);
              //     console.log(i.currservicePeopleList);
              //   }
              // }

              // for (let i of this.tableData) {
              //   // i.currservicePeopleList.push(...data);
              //   console.log(i);
              //   for (let j of i.currservicePeopleList) {
              //     console.log(j);
              //     console.log(data);

              //     // i.currservicePeopleList.push(...data);
              //   }
              //   console.log(i.currservicePeopleList);
              // }
              this.currservicePeoples = data;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        }, 200);
      } else if (query.length == 11) {
        // this.loading = true;
        this.currservicePeoplesList = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query
          };
          findUserList(params).then(res => {
            console.log(res);
            let data = JSON.parse(res.data);
            this.currservicePeoplesList = data;
          });
        }, 200);
      } else if (query.length == 0) {
        this.currservicePeoplesList = [];
      } else {
        this.classifySelects = [];
      }
    },
    toDetail(index, row) {
      console.log(row);
      let obj = {
        label: "工单信息",
        value: "/salesCloud/workOrder/detail",
        query: { id: row.workId }
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query
      });
    },
    blurDataSource(scope) {
      // console.log(scope.row.datas.split(/[(\r\n)\r\n]+/));
      if (scope.row.datas) {
        scope.row.dataSourceList = scope.row.datas.split(/[(\r\n)\r\n]+/);
      }
      if (scope.row.currControlType.value == "CHECKBOX") {
        scope.row.data.dynamicCheckList = [];
      }
      console.log(scope);
    },
    changeIsReminder(scope) {
      console.log(scope);
      if (scope.row.isMessageReminder == "YES") {
        scope.row.message = "单位：月";
        scope.row.currControlType = {};
        scope.row.currControlType.value = "INT_INPUT";
        scope.row.currControlType.label = "整数输入文本框";
      } else {
        scope.row.message = "";
        scope.row.currControlType = {};
        scope.row.currControlType.value = "INT_INPUT";
        scope.row.currControlType.label = "整数输入文本框";
      }
    },
    changeInputType(type, scope) {
      console.log(type, scope);
      if (type.value == "SELECT_ENGINEER") {
        // let params = {};
        // params.userType = "JOINS_ENGINEER";
        // findUsersAll(params).then(res => {
        //   let data = JSON.parse(res.data);
        //   scope.row.selectEngineerList = data.rows;
        // });
      }
      if (type.value == "MULTIPLE_SELECT_ENGINEER") {
        // let params = {};
        // params.userType = "JOINS_ENGINEER";
        // findUsersAll(params).then(res => {
        //   let data = JSON.parse(res.data);
        //   scope.row.multipleSelectEngineerList = data.rows;
        //   console.log(scope);
        // });
      }
    },
    choseServiceItem(e) {
      console.log(e);
    },
    choseWorkServiceItem(serviceCategory, scope) {
      console.log(serviceCategory, scope);
      findItemsByCategory(serviceCategory.id).then(res => {
        let data = JSON.parse(res.data);
        scope.row.joinsWorkServiceItems = data;
        console.log(data);
      });
      this.serviceItem = "";
    },
    chooseProvince(e, scope) {
      console.log(e);
      console.log(scope);
      findCitys(e.id).then(res => {
        this.citys = res.data;
        scope.row.currentCity = "";
        this.currentArea = "";
      });
    },
    chooseCity(e, scope) {
      console.log(e);
      console.log(scope);
      findAreas(e.id).then(res => {
        this.areas = res.data;
        this.currentArea = "";
      });
    },
    chooseArea(e) {
      console.log(e);
    },
    submit() {
      let item = {
        label: "编辑客户信息",
        value: "/salesCloud/customerInfo/view"
      };

      this.$store.commit("DEL_TAG", item);
      let obj = {
        value: "/salesCloud/customerInfo",
        label: "客户信息管理"
      };
      this.$router.push({
        path: resolveUrlPath(obj.value, obj.label),
        query: obj.query
      });
    },
    handleSteppingDelete(index, row) {
      //   this.propertiesList.splice(index, 1);

      this.tableData.splice(index, 1);
    },
    handleStepping1Delete(index, row) {
      //   this.propertiesList.splice(index, 1);

      this.tableData1.splice(index, 1);
    },
    handleAddRows(index, row) {
      console.log(this.tableData);
      let list = {
        joinsWorkServiceItems: [],
        currservicePeopleList: []
      };
      this.tableData.push(list);
    },
    handleAdd1Rows(index, row) {
      console.log(this);
      console.log(this.tableData1);
      let list = {
        currControlType: {},
        dataSourceList: [], //参数数据列表
        dynamicCheckList: [], //多选
        selectEngineer: {},
        multipleSelectEngineer: {},
        point: {},
        multipleSelectEngineerList: [],
        selectEngineerList: [],
        isMessageReminder: "NO",
        fileList: [],
        data: {}
      };
      this.tableData1.push(list);
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file, fileList) {
      console.log(this);
      console.log(file, fileList);
      for (let item of this.tableData1) {
        for (let i of item.fileList) {
          console.log(i);
          if (i.uid == file.uid) {
            console.log(item);
            item.fileList = fileList;
          }
        }
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 9 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    isIndex(row, index) {
      console.log(row, index);
      this.currIndex.index = index;
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      console.log(option);
      var obj = {};
      obj.name = option.file.name;
      getAliyunPublicToken().then(res => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then(results => {
            console.log(results);
            console.log(this.tableData1);
            console.log(this.currIndex);
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            // this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            obj.url = array[0];
            console.log(this.tableData1[this.currIndex.index]);
            this.tableData1[this.currIndex.index].fileList.push(obj);
            //上传多张图片
            if (this.tableData1[this.currIndex.index].image == undefined) {
              this.tableData1[this.currIndex.index].image = array[0];
            } else {
              let aa = "";
              this.tableData1[this.currIndex.index].image = aa.concat(
                this.tableData1[this.currIndex.index].image,
                ",",
                array[0]
              );
              console.log(this.tableData1[this.currIndex.index].image);
            }
            // 上传单张图片
            // this.tableData1[this.currIndex.index][0].projectGuaranteeList[
            //   this.currIndex.idx
            // ].image = array[0];
            console.log(obj);
            // this.fileList.push(obj);
            this.tableLoading = false;
          })
          .catch(err => {
            console.log(err);
          });
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 8) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
};
</script>

<style>
</style>